const bundleobserver = new MutationObserver((mutations) => {
  if ($('.qbk-bundle__main-content').length > 0) {

    $('.qbk-bundle__main-content').after(`
      <div class="pricing-box">
        <div class="item-total">
          <span>Selected Items Total</span>
          <span class="dynamic"></span>
        </div>
      
        <div class="bundle-price">
          <span>Bundle Price</span>
          <span class="dynamic"></span>
        </div>
      
        <div class="you-save">
          <span style="font-weight:600;">You Save</span>
          <span class="dynamic"></span>
        </div>
    </div>

    `);
    $('.qbk-bundle-action').after(`
      <div class="button button--secondary button--full-width bundle-btn ">
        Add Selected To Cart
      </div>
    `);

       setTimeout(function(){
       let OriginalPrice = $('.qbk-bundle__total-value .qbk-offer__price--origin').text();
       let OfferPrice =  $('.qbk-bundle__total-value .qbk-offer__price--offer').text() ;
       $('.item-total .dynamic').text(OriginalPrice);
       $('.bundle-price .dynamic').text(OfferPrice);
      let savings = Number(OriginalPrice.slice(1))-Number(OfferPrice.slice(1));
        $('.you-save .dynamic').text( OriginalPrice.trim().charAt(0) + savings );
         
         
       }, 2000);
          $('.bundle-btn').on('click', function () {
          $('.qbk-btn').trigger('click');
      });
    
    bundleobserver.disconnect(); 
  }
});

bundleobserver.observe(document.body, {
  childList: true,
  subtree: true
});


(function () {
    const FROM_SIZE = '100x100';
    const TO_SIZE = '500x500';
    const TARGET_CLASS = 'qbk-offer__image';

    function upgradeBackgroundImage(element) {
        const style = getComputedStyle(element);
        const backgroundImage = style.backgroundImage;
        const match = backgroundImage.match(/url\(["']?(.*?)["']?\)/);
        if (!match || !match[1]) return;

        const imageUrl = match[1];

        // Prevent double-processing
        if (imageUrl.includes(TO_SIZE)) return;

        const img = new Image();
        img.onload = function () {
            const newUrl = imageUrl.replace(FROM_SIZE, TO_SIZE);
            element.style.backgroundImage = `url("${newUrl}")`;
        };
        img.src = imageUrl;
    }

    function scanAndUpgrade() {
        document.querySelectorAll(`.${TARGET_CLASS}`).forEach(el => {
            upgradeBackgroundImage(el);
        });
    }

    // Run when DOM is ready
    document.addEventListener("DOMContentLoaded", () => {
        scanAndUpgrade();
    });

    // Watch for future elements
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType !== 1) return;

                if (node.classList && node.classList.contains(TARGET_CLASS)) {
                    upgradeBackgroundImage(node);
                }

                // Also check any matching children
                node.querySelectorAll?.(`.${TARGET_CLASS}`).forEach(child => {
                    upgradeBackgroundImage(child);
                });
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();










$(window).on('load', function() {
  var $slider = $('.product__media-list');
  var $slides = $slider.children('.product__media-item');

  if ($slides.length < 2) return;

  var cloneTimes = 10;
  for (var i = 0; i < cloneTimes; i++) {
    var $clones = $slides.clone(true);
    $slider.append($clones);
  }

});



